module.exports = __webpack_public_path__ + "static/media/04.71631f29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/04.jpg
// module id = 24
// module chunks = 0